import React, { Suspense, lazy } from 'react';
import { SkeletonChart } from './feedback/Skeleton';

// Lazy load the heavy analysis components
const AnalysisTabsWithSwipe = lazy(() => import('./AnalysisTabsWithSwipe'));

interface LazyAnalysisTabsProps {
  activeKpi: string;
  kpiName: string;
  latestYear: number;
  trendData: any;
  dynamicTrendData: any;
  distributionData: any;
  dynamicDistributionData: any;
  driverData: any;
  insightData: any;
  correlationData: any;
  riketData: any;
  kommunId?: string;
  skolaId?: string | null;
  loading: boolean;
  defaultTab?: string;
}

const LazyAnalysisTabs: React.FC<LazyAnalysisTabsProps> = (props) => {
  return (
    <Suspense 
      fallback={
        <div className="space-y-4">
          <SkeletonChart className="h-64" />
          <SkeletonChart className="h-48" />
          <SkeletonChart className="h-48" />
        </div>
      }
    >
      <AnalysisTabsWithSwipe {...props} />
    </Suspense>
  );
};

export default LazyAnalysisTabs;
